import {
    GET_EXAM_ROOM_ASSIGNMENTS,
    GET_EXAM_ROOM_ASSIGNMENTS_FAIL,
    GET_EXAM_ROOM_ASSIGNMENTS_SUCCESS,
    ADD_NEW_EXAM_ROOM_ASSIGNMENT,
    ADD_EXAM_ROOM_ASSIGNMENT_SUCCESS,
    ADD_EXAM_ROOM_ASSIGNMENT_FAIL,
    UPDATE_EXAM_ROOM_ASSIGNMENT,
    UPDATE_EXAM_ROOM_ASSIGNMENT_SUCCESS,
    UPDATE_EXAM_ROOM_ASSIGNMENT_FAIL,
    DELETE_EXAM_ROOM_ASSIGNMENT,
    DELETE_EXAM_ROOM_ASSIGNMENT_SUCCESS,
    DELETE_EXAM_ROOM_ASSIGNMENT_FAIL,
    RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS,

    GENERATE_EXAM_ROOM_SEATS, 
    GENERATE_EXAM_ROOM_SEATS_SUCCESS, 
    GENERATE_EXAM_ROOM_SEATS_FAIL,

    GET_EXAM_ROOM_SEATS, 
    GET_EXAM_ROOM_SEATS_SUCCESS, 
    GET_EXAM_ROOM_SEATS_FAIL,

    RESET_EXAM_ROOM_SEATS, 
    RESET_EXAM_ROOM_SEATS_SUCCESS, 
    RESET_EXAM_ROOM_SEATS_FAIL,



  
} from "./actionTypes";

export const getExamRoomAssignments = () => ({
  type: GET_EXAM_ROOM_ASSIGNMENTS,
})

export const getExamRoomAssignmentsSuccess = examRoomAssignments => ({
  type: GET_EXAM_ROOM_ASSIGNMENTS_SUCCESS,
  payload: examRoomAssignments,
})

export const getExamRoomAssignmentsFail = error => ({
  type: GET_EXAM_ROOM_ASSIGNMENTS_FAIL,
  payload: error,
})

export const addNewExamRoomAssignment = data => ({
  type: ADD_NEW_EXAM_ROOM_ASSIGNMENT,
  payload: data,
})

export const addExamRoomAssignmentSuccess = examRoomAssignment => ({
  type: ADD_EXAM_ROOM_ASSIGNMENT_SUCCESS,
  payload: examRoomAssignment,
})

export const addExamRoomAssignmentFail = error => ({
  type: ADD_EXAM_ROOM_ASSIGNMENT_FAIL,
  payload: error,
})

export const updateExamRoomAssignment = examRoomAssignment => ({
  type: UPDATE_EXAM_ROOM_ASSIGNMENT,
  payload: examRoomAssignment,
})

export const updateExamRoomAssignmentSuccess = examRoomAssignment => ({
  type: UPDATE_EXAM_ROOM_ASSIGNMENT_SUCCESS,
  payload: examRoomAssignment,
})

export const updateExamRoomAssignmentFail = error => ({
  type: UPDATE_EXAM_ROOM_ASSIGNMENT_FAIL,
  payload: error,
})

export const deleteExamRoomAssignment = data => ({
  type: DELETE_EXAM_ROOM_ASSIGNMENT,
  payload: data,
})

export const deleteExamRoomAssignmentSuccess = data => ({
  type: DELETE_EXAM_ROOM_ASSIGNMENT_SUCCESS,
  payload: data,
})

export const deleteExamRoomAssignmentFail = error => ({
  type: DELETE_EXAM_ROOM_ASSIGNMENT_FAIL,
  payload: error,
})

// ─── Places ───────────────────────────────────────────────────────────────────
export const generateExamRoomSeats        = (uuid)   => ({ 
    type: GENERATE_EXAM_ROOM_SEATS,         
    payload: uuid 
});
export const generateExamRoomSeatsSuccess = (data)   => ({ 
    type: GENERATE_EXAM_ROOM_SEATS_SUCCESS,  
    payload: data 
});
export const generateExamRoomSeatsFail    = (error)  => ({ 
    type: GENERATE_EXAM_ROOM_SEATS_FAIL,     
    payload: error 
});

export const getExamRoomSeats        = (uuid)   => ({ 
    type: GET_EXAM_ROOM_SEATS,         
    payload: uuid 
});
export const getExamRoomSeatsSuccess = (data)   => ({ 
    type: GET_EXAM_ROOM_SEATS_SUCCESS,  
    payload: data 
});
export const getExamRoomSeatsFail    = (error)  => ({ 
    type: GET_EXAM_ROOM_SEATS_FAIL,     
    payload: error 
});

export const resetExamRoomSeats        = (uuid)   => ({ 
    type: RESET_EXAM_ROOM_SEATS,         
    payload: uuid 
});
export const resetExamRoomSeatsSuccess = ()        => ({ 
    type: RESET_EXAM_ROOM_SEATS_SUCCESS 
});
export const resetExamRoomSeatsFail    = (error)   => ({ 
    type: RESET_EXAM_ROOM_SEATS_FAIL,    
    payload: error 
});


export const resetExamRoomAssignmentLastActionSuccess = () => ({
    type: RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS,
});

